
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {MdbsCore} from "@/api/tsclient";
import {rolesModule, usersModule} from "@/store";
import {deepCopy} from "@/auxillary";
import IRoleDto = MdbsCore.IRoleDto;
import UserCreateDto = MdbsCore.UserCreateDto;
import IUserCreateDto = MdbsCore.IUserCreateDto;
import {rules} from "@/auxillary/rules";

@Component({})
export default class UserCreateDialog extends Vue {
  @Prop({required: true})
  user!: IUserCreateDto;

  currentUser: IUserCreateDto = new UserCreateDto();
  deactivate = false;

  valid: boolean = false;
  saving: boolean = false;
  rules = rules;

  get allRoles(): IRoleDto[] {
    return rolesModule.roles;
  }

  get rolesLoading() {
    return rolesModule.isLoading;
  }

  getRoleName(role: IRoleDto) {
    return `${role.displayName} (${role.identifier})`;
  }

  @Watch('user', {immediate: true, deep: true})
  async onUserChanged(user: IUserCreateDto | null) {
    if (user == null) {
      return;
    }

    this.currentUser = deepCopy(user);
    Vue.nextTick(() => {
      this.form.validate();
    });
    await rolesModule.loadAll();
  }

  get form(): Vue & { validate: () => boolean } {
    return this.$refs.form as Vue & { validate: () => boolean }
  }

  async save() {
    try {
      this.saving = true;
      await usersModule.createCompleteUser({
        user: this.currentUser,
        deactivate: this.deactivate
      });

      this.$emit('save');
    } finally {
      this.saving = false;
    }
  }

  async cancel() {
    this.$emit('cancel');
  }
}
